import { useEffect, useState } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { _UBLDiscrepancyResponse } from '../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../theme/Component/Modal';
import { UBLDiscrepancyResponse } from './UBLDiscrepancyResponse';

interface Props {
    label?: string;
    idSelector: number;
    onChange: (value: any) => void;
    disabled?: boolean;
}

export const EditorUBLDiscrepancyResponse = ({ idSelector, label, onChange, disabled }: Props) => {
    const { instance } = useDataBean(_UBLDiscrepancyResponse);

    const modal = useModal("Catalogo de Respuestas de Discrepancia", MODAL_LG);

    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});

    const getProperties = (item: any) => {
        return item?.DataBeanProperties ?? item ?? {};
    };

    const getDisplayValue = (item: any) => {
        const data = getProperties(item);

        if (!data?.IDUBLDiscrepancyResponse && !data?.Name) {
            return '';
        }

        return `${data.Code ?? data.IDUBLDiscrepancyResponse ?? ''} - ${data.Name ?? ''}`;
    };

    useEffect(() => {
        if (idSelector) {
            getItem();
        } else {
            setValor('');
            setObj({});
        }
    }, [idSelector]);

    const getItem = () => {
        instance.getUBLDiscrepancyResponse(idSelector).then((resp: any) => {
            setObj(resp);
            setValor(getDisplayValue(resp));
            onChange(resp);
        }).catch(() => {
            toast.error("Respuesta de discrepancia no encontrada");
            setValor('');
            setObj({});
        });
    };

    const returnValue = () => {
        const data = getProperties(obj);

        if (data?.IDUBLDiscrepancyResponse) {
            setValor(getDisplayValue(obj));
            modal.close();
            onChange(obj);
        } else {
            toast.error("Respuesta de discrepancia no valida");
        }
    };

    return (
        <>
            {label && label !== " " && (
                <label>{label ?? "Seleccione una respuesta de discrepancia"}</label>
            )}

            <div
                className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        modal.open();
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal
                onSubmitLabel="Seleccionar"
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={returnValue}
            >
                <UBLDiscrepancyResponse
                    isModal
                    _onChange={(e: any) => {
                        setObj(e);
                    }}
                />
            </Modal>
        </>
    );
};
